import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SearchUnitModal } from "./modal/modal.component";

@Component({
  selector: "app-search-units",
  templateUrl: "./search-units.component.html",
})
export class SearchUnitsComponent {
  constructor(public dialog: MatDialog) {}

  open() {
    this.dialog
      .open(SearchUnitModal, {
        panelClass: [
          "modal-for-search-box",
          "overflow-hidden",
          "w-full",
          "lg:w-1/2",
        ],
      })
      .afterClosed()
      .toPromise();
  }
}
